import React from 'react';
import { motion } from 'framer-motion';

const ProblemSolution = ({
    subtitle = "THE CHALLENGE VS THE SOLUTION",
    title = "Why Traditional Methods Fail",
    challenges = [
        "Fake experience and forged documents",
        "Delays due to manual background checks",
        "High operational cost and human errors",
        "Compliance and legal risks"
    ],
    solutionTitle = "How Coin Circle Trust Solves It",
    solutionDescription = (
        <>
            Coin Circle Trust uses <span className="font-bold text-white">Artificial Intelligence</span> to automate the entire background verification process—from candidate initiation to final report—ensuring speed, accuracy, and compliance at scale.
        </>
    ),
    stats = [
        { value: "10x", label: "Faster Processing" },
        { value: "100%", label: "Automated" }
    ]
}) => {

    return (
        <section className="container-padding-x py-16 bg-white">
            <div className="text-center mb-12">
                <h4 className="text-[#168DEF] font-bold text-sm uppercase tracking-wider mb-2">{subtitle}</h4>
                <h2 className="text-[#0F172A] text-4xl font-bold">{title}</h2>
            </div>

            <div className="grid md:grid-cols-2 gap-8 max-w-6xl mx-auto">
                {/* Challenges Column */}
                <div className="bg-[#EFF6FF] rounded-2xl p-8 border border-[#BFDBFE]">
                    <div className="flex items-center gap-3 mb-6">
                        <div className="bg-[#BFDBFE] p-2 rounded-full bg-opacity-50 text-[#1E40AF]">
                            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path>
                            </svg>
                        </div>
                        <h3 className="text-[#1E40AF] text-2xl font-bold">The Hiring Challenges</h3>
                    </div>

                    <div className="space-y-4">
                        {challenges.map((challenge, index) => (
                            <motion.div
                                key={index}
                                initial={{ opacity: 0, x: -20 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                viewport={{ once: true }}
                                transition={{ delay: index * 0.1 }}
                                className="bg-white p-4 rounded-xl shadow-sm flex items-center gap-4 text-[#1E40AF]"
                            >
                                <svg className="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                                </svg>
                                <span className="text-[#1E40AF] font-medium">{challenge}</span>
                            </motion.div>
                        ))}
                    </div>
                </div>

                {/* Solution Column */}
                <div className="bg-[#168DEF] rounded-2xl p-8 text-white relative overflow-hidden">

                    <div className="flex items-center gap-3 mb-6 relative z-10">
                        <div className="bg-white/20 p-2 rounded-full">
                            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                            </svg>
                        </div>
                        <h3 className="text-white text-2xl font-bold">{solutionTitle}</h3>
                    </div>

                    <p className="text-blue-50 text-lg leading-relaxed mb-12 relative z-10">
                        {solutionDescription}
                    </p>

                    {stats && stats.length > 0 && (
                        <div className="grid grid-cols-2 gap-4 relative z-10">
                            {stats.map((stat, index) => (
                                <div key={index} className="bg-[#2563EB] p-4 rounded-xl">
                                    <div className="text-3xl font-bold mb-1">{stat.value}</div>
                                    <div className="text-blue-200 text-sm">{stat.label}</div>
                                </div>
                            ))}
                        </div>
                    )}

                    {/* Decorative Background Circle */}
                    <div className="absolute -bottom-12 -right-12 w-64 h-64 bg-blue-500 rounded-full opacity-20 blur-3xl z-0"></div>

                </div>
            </div>
        </section>
    );
};

export default ProblemSolution;
